module.exports = __webpack_public_path__ + "img/logo-title-black.3a98d5ec.png";